var React = require('react');

function PrevInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.602438 6.00007C0.602438 6.22007 0.682428 6.42007 0.842428 6.58007L6.04243 11.5801C6.20243 11.7201 6.40244 11.8001 6.60244 11.8001C6.82244 11.8001 7.02244 11.7201 7.18244 11.5601C7.48244 11.2401 7.48245 10.7401 7.16245 10.4201L2.56245 6.00007L7.16245 1.58007C7.48245 1.28007 7.48244 0.760073 7.18244 0.440073C6.88244 0.120073 6.36243 0.120071 6.04243 0.420071L0.842428 5.42007C0.682428 5.58007 0.602438 5.78007 0.602438 6.00007Z","fill":"white"}));
}

PrevInline.defaultProps = {"width":"8","height":"12","viewBox":"0 0 8 12","fill":"none"};

module.exports = PrevInline;

PrevInline.default = PrevInline;
